export default __webpack_public_path__ + "static/media/united-states.3b5a3c1c.svg";